module.exports = __webpack_public_path__ + "media/images/emblems/Le_Vaud-coat_of_arms-98f5f770e555720cdc0f4de66c110b4e.svg";